<template>
  <div>
    <sub-content-container :title="$t('aboutMe.courses.pageLabel')">
      <course :courses="completeCourses" />
    </sub-content-container>
  </div>
</template>

<script>
const SubContentContainer = () =>
  import(
    /* webpackChunkName: "SubContentContainerComponent" */ "@/components/Global/SubContentContainer.vue"
  );
const Course = () =>
  import(/* webpackChunkName: "CoursesPage" */ "@/components/AboutMe/Course.vue");

export default {
  name: "Courses",
  components: {
    SubContentContainer,
    Course
  },
  data() {
    return {
      courses: [
        {
          name: "Curso de SEO y Posicionamiento en Google",
          href: "https://www.udemy.com/certificate/UC-bb5dddb1-6f9e-475d-86e5-70eff045df3e/",
          site: "Udemy",
          logotype: "/img/courseSitesLogotype/udemy.jpg"
        },
        {
          name: "Introducción al Testing de Software: para Principiantes!",
          href: "https://www.udemy.com/certificate/UC-F5W4N3ZI/",
          site: "Udemy",
          logotype: "/img/courseSitesLogotype/udemy.jpg"
        },
        {
          name: "Angular: De cero a experto (Angular 10+)",
          href: "https://www.udemy.com/certificate/UC-39F8QWWH/",
          site: "Udemy",
          logotype: "/img/courseSitesLogotype/udemy.jpg"
        },
        {
          name: "JavaScript : ECMAScript 6 y Todos Sus Detalles",
          href: "https://www.udemy.com/certificate/UC-63A4ND1D/",
          site: "Udemy",
          logotype: "/img/courseSitesLogotype/udemy.jpg"
        },
        {
          name: "JavaScript de Trabajo con el modelo de objetos de documento y plugins jQuery",
          href: "https://alison.com/es/usuario/pdf/888/1",
          site: "Alison – Free Online Learning",
          logotype: "/img/courseSitesLogotype/alison.png"
        },
        {
          name: "JavaScript Application Programming",
          href: "https://alison.com/es/usuario/pdf/887/1",
          site: "Alison – Free Online Learning",
          logotype: "/img/courseSitesLogotype/alison.png"
        }
      ]
    };
  },
  computed: {
    completeCourses() {
      return this.courses.map((data, i) => ({
        ...data,
        ...this.$t("aboutMe.courses.coursesData")[i]
      }));
    }
  }
};
</script>
